import React from 'react';

const VerdictBanner = ({ verdict, scoreColor }) => {
    if (!verdict) return null;

    return (
        <div className="card verdict-card" style={{
            background: `${scoreColor}12`,
            border: `1px solid ${scoreColor}40`,
            boxShadow: `0 0 20px ${scoreColor}15`,
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Subtle accent glow */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '4px',
                height: '100%',
                background: scoreColor,
                boxShadow: `0 0 15px ${scoreColor}88`
            }} />

            <div className="verdict-content" style={{ display: 'flex', alignItems: 'center', gap: '28px' }}>
                <span className="verdict-emoji" style={{ fontSize: '3rem', filter: `drop-shadow(0 0 10px ${scoreColor}44)` }}>
                    {verdict.verdict_emoji}
                </span>
                <div>
                    <h2 className="verdict-label" style={{
                        color: scoreColor,
                        margin: '0 0 8px 0',
                        fontFamily: "'Iowan Old Style', 'Palatino Linotype', 'Palatino', 'Georgia', serif",
                        fontSize: '2rem',
                        fontWeight: '600',
                        letterSpacing: '-0.01em'
                    }}>
                        {verdict.verdict_label}
                    </h2>
                    <p className="verdict-text" style={{
                        margin: 0,
                        color: 'var(--text-secondary)',
                        fontSize: '1.15rem',
                        lineHeight: '1.6',
                        fontWeight: '400'
                    }}>
                        {verdict.verdict_text}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default VerdictBanner;
